/**
 * Content-Type header.
 *
 * @group DRM
 *
 * @beta
 */
export const CONTENT_TYPE = 'Content-Type';
//# sourceMappingURL=CONTENT_TYPE.js.map